var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((this.users),function(user){return _c('UserRow',{key:user.id,attrs:{"user":user},on:{"deleteUser":_vm.deleteUser}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }